var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gaurav-impex-logo d-flex align-center"},[_c('AppLogo',{class:{
      'small-logo': _vm.variant == 'small',
      'x-medium-logo': _vm.variant == 'x-medium',
      'medium-logo': _vm.variant == 'medium',
      'large-logo': _vm.variant == 'large'
    }}),_c('div',{class:{
      'logo-title': true,
      'large-font ml-2 mb-2': _vm.variant == 'large',
      'x-medium-font ml-2 mb-2': _vm.variant == 'x-medium',
      'medium-font ml-2 mb-2': _vm.variant == 'medium',
      'small-font ml-1 mb-1': _vm.variant == 'small'
    }},[_vm._v(" "+_vm._s(_vm.appName)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }